/* eslint-disable */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Triangle = styled.div`
  position: absolute;
  right: ${props => props.right};
  top: ${props => props.top};
  width: 0;
  height: 0;
  border-left: ${props => props.size} solid transparent;
  border-right: ${props => props.size} solid transparent;
  border-bottom: ${props => props.size} solid
    ${props => props.color || props.theme.components.triangle.color};

  ${props =>
    props.withContent &&
    `
    :before {
      content: "${props.content || "+"}";
      font-size: ${props.contentSize || "14px"}
      font-weight: ${props.contentFontWeight || "100"}
      color: ${props.contentColor || "#fff"}
      height: ${props.size};
      width: calc(${props.size} * 2);
      top: calc(${props.size} / 2);
      right: ${props.size};
      background-color: transparent;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: center;
    }
  `};

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    border-left: ${props => props.XsSize} solid transparent;
    border-right: ${props => props.XsSize} solid transparent;
    border-bottom: ${props => props.XsSize} solid ${props => props.color};
    top: ${props => props.XsTop};

    ${props =>
      props.withContent &&
      `
      :before {
        font-size: ${props.XsContentSize || "14px"};
        height: ${props.XsSize};
        width: calc(${props.XsSize} * 2);
        top: calc(${props.XsSize} / 2);
        right: ${props.XsSize};
      }
  `};
`;

Triangle.defaultProps = {
  withContent: false
};

Triangle.propTypes = {
  right: PropTypes.string,
  top: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  rotate: PropTypes.string,
  XsSize: PropTypes.string,
  XsTop: PropTypes.string,
  withContent: PropTypes.bool,
  content: PropTypes.string,
  contentSize: PropTypes.string,
  contentFontWeight: PropTypes.string,
  XsContentSize: PropTypes.string,
  contentColor: PropTypes.string
};

export default Triangle;
